import { render, staticRenderFns } from "./PosVatSalesSummary.vue?vue&type=template&id=4429ac48&"
import script from "./PosVatSalesSummary.vue?vue&type=script&lang=js&"
export * from "./PosVatSalesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports